import type { ConversationRole } from './member';

// Permission keys (expected from backend)
export const PERMISSION_KEYS = {
  MESSAGE_SEND: 'MESSAGE_SEND',
  MESSAGE_DELETE_OWN: 'MESSAGE_DELETE_OWN',
  MESSAGE_DELETE_ANY: 'MESSAGE_DELETE_ANY',
  MESSAGE_EDIT: 'MESSAGE_EDIT',
  MESSAGE_PIN: 'MESSAGE_PIN',
  MEMBER_ADD: 'MEMBER_ADD',
  MEMBER_REMOVE: 'MEMBER_REMOVE',
  ROLE_ASSIGN: 'ROLE_ASSIGN',
  TRANSFER_OWNERSHIP: 'TRANSFER_OWNERSHIP',
  CONVERSATION_UPDATE: 'CONVERSATION_UPDATE'
} as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[keyof typeof PERMISSION_KEYS];

// Override actions
export type PermissionAction = 'ALLOW' | 'DENY' | 'INHERIT';

// DTOs
export interface UserPermissionsDto {
  conversationId: string;
  userId: string;
  role: ConversationRole;
  permissions: string[];
}

export interface PermissionOverrideItemDto {
  permissionKey: string;
  action: PermissionAction;
}

export interface UserPermissionOverridesDto {
  conversationId: string;
  userId: string;
  baseRole: ConversationRole;
  overrides: PermissionOverrideItemDto[];
}

// Request DTOs
export interface AssignRoleRequestDto {
  role: ConversationRole;
  targetUserId: string;
}

export interface TransferOwnershipRequestDto {
  newOwnerId: string;
}

export interface UpdatePermissionOverridesRequestDto {
  permissions: PermissionOverrideItemDto[];
}
